import { createFileRoute } from '@tanstack/react-router';
import Statistics from 'src/pages/Organization/Statistics';

export const Route = createFileRoute('/$organizationSlug/statistics/$')({
  component: Statistics,
});
